<template>
  <section class="login-body">

    <!-- Normáli login -->
    <div v-if="shibLogin == false" class="login-panel">
      <div class="login-panel-head">
        <h1><i class="kricon fa fa-id-card-o"></i><h1>KMR<span> - Kártya menedzsment rendszer</span></h1></h1>
        <p>A Széchenyi István Egyetem kártya menedzsment felülete.</p>
      </div>
      <div class="login-panel-body">
        <h2>Bejelentkezés</h2>
        <form>
          <inputbox id="username" label="Felhasználónév" :keydownEnter="login" v-bind:errors="errors" name="username" v-model="form.username"></inputbox>
          <passwordbox id="password" label="Jelszó" :keydownEnter="login" v-bind:errors="errors" name="password" v-model="form.password"></passwordbox>
          <div class="form-actions clearfix">
            <button class="btn btn-primary pull-right" type="button" v-on:click="login">Bejelentkezés</button>
            <button v-if="shibLogin == false" style="margin-right: 5px;" class="btn btn-primary pull-right" type="button" v-on:click="switchLogin">Bejelentkezés címtárral</button>
          </div>
        </form>
      </div>
    </div>

    <!-- Shibbolet login -->
    <section v-if="shibLogin == true" class="shib_login-panel">
      <div class="shib_load"></div>
      <button class="btn btn-primary pull-right shibback" type="button" v-on:click="switchLogin">Címtár nélküli bejelentkezés</button>
      <iframe frameborder="0" :src="shibLoginUrl" width="800px" height="655px" />
    </section>

  </section>
</template>

<script>
export default {
  data: function () {
    return {
      form: {
        username: '',
        password: ''
      },
      errors: [
      ],
      shibLogin: true
    }
  },
  computed: {
    shibLoginUrl: function() {
      return location.protocol+"//"+location.host+"/Shibboleth.sso/Login?target="+location.protocol+"//"+location.host+"/api/users/shib_login_redirect";
    }
  },
  methods: {
    login: function (event) {
      var _this = this;

      this.$root.ajax('users/login', {
        method: 'POST',
        data: this.form,
        success: function(response) {
          if (response.errors.length > 0) {
            _this.errors = response.errors;
          } else {
            _this.$root.$data.user = response.user;
            _this.$router.push({path: '/home'});
          }
        }
      });
    },switchLogin: function (event) {
      this.shibLogin  = !this.shibLogin;
    }
  }
}
</script>


// WEBPACK FOOTER //
// login.vue?40f1e900